module.exports = __webpack_public_path__ + "img/jgsb1.94971741.png";